module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Marta_Grabowska.c87c2a7c.jpg";